<template>
  <v-dialog v-model="show" persistent max-width="500">
    <v-card>
      <v-card-title class="headline">Edit Category</v-card-title>
      <v-card-text>
        <v-form v-if="form" ref="form">
          <label class="text-field-label pl-4"> Label </label>
          <v-text-field
            flat solo rounded
            required
            background-color="grey lighten-3"
            class="mt-2"
            v-model="form.label"
          ></v-text-field>
          <div class="category-image mb-5">
            <input v-model="form.image" hidden />
            <div class="category-image-container" v-if="categoryImage">
              <div class="category-image-delete">
                <v-btn color="error" @click="removeImage" depressed small>
                  Remove
                </v-btn>
              </div>
              <v-img
                class="mb-4"
                :src="categoryImage"
                :lazy-src="categoryImage"
                size="100%"
              />
            </div>
            <div class="drop py-10" v-else>
              <v-btn elevation="0" small @click="showCropperModal = !showCropperModal">Select cover image</v-btn>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn @click="show = false" text>Cancel</v-btn>
        <v-btn @click="updateCategory" color="primary" :loading="loading" depressed>Save</v-btn>
      </v-card-actions>
    </v-card>
    <image-cropper
      :aspect-ratio="16 / 9"
      v-model="showCropperModal"
      @change="imageChanged"
    />
  </v-dialog>
</template>

<script>
import Form from '@/utils/form'
import { mapState, mapActions } from 'vuex'
import ImageCropper from '@/components/modals/ImageCropper'

export default {
  components: {
    ImageCropper
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      show: this.value,
      showCropperModal: false,
      categoryImage: null,
      loading: false,
      form: new Form({
        label: null,
        image: null
      })
    }
  },

  computed: {
    ...mapState({
      currentCategory: state => state.category.currentCategory
    })
  },

  methods: {
    ...mapActions({
      getAllCategories: 'category/getAllCategories'
    }),

    updateCategory () {
      this.loading = true

      const formData = new FormData()
      formData.append('label', this.form.label)

      if (this.form.image) {
        formData.append('image', this.form.image)
      }

      this.$api.post(`/categories/${this.currentCategory.id}`, formData)
        .then(async () => {
          await this.getAllCategories()
          this.show = false
        })
        .finally(() => (this.loading = false))
    },

    imageChanged (image) {
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.categoryImage = reader.result
        this.form.image = image
      }
    },

    removeImage () {
      this.categoryImage = null
      this.form.image = null
    }
  },

  watch: {
    value (val) {
      this.show = val

      this.form = {
        label: this.currentCategory.label
      }

      this.categoryImage = this.currentCategory.cover_photo
        ? this.currentCategory.cover_photo.url
        : null
    },

    show (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.drop {
  background-color: #f2f2f2;
  border: 4px dashed #ccc;
  background-color: #f6f6f6;
  border-radius: 2px;
  height: 100%;
  max-height: 400px;
  max-width: 600px;
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.category-image-container {
  position: relative;
}

.category-image-delete {
  position: absolute;
  z-index: 99;
  top: 10px;
  right: 10px;
}
</style>
